export const BOARD_TYPES = {
	self_catering: "Self Catering",
	bed_and_breakfast: "Bed & Breakfast",
	dinner_bed_and_breakfast: "Dinner, Bed & Breakfast",
	semi_all_inclusive: "Semi All Inclusive",
	all_inclusive: "All Inclusive",
	half_board: "Half Board",
	full_board: "Full Board",
}
